module.exports = __webpack_public_path__ + "media/country_flags/fo-9af1d2a3.png";